export default __webpack_public_path__ + "logo-e4ee1f019cdee3444edbee965d4d3e63.png";